/** Demo DSE rows for promotional landing embeds (API + score widgets). */
export const PROMO_DEMO_DSE_SCORES = [
  { subjectCode: 'CHI', score: '5*' },
  { subjectCode: 'ENG', score: '5' },
  { subjectCode: 'MAT', score: '5**' },
  { subjectCode: 'CSD', score: 'Attained' },
  { subjectCode: 'BIO', score: '5' },
  { subjectCode: 'CHE', score: '4' },
];

/** Fallback programme cards when recommendations API is unavailable. */
export const PROMO_FALLBACK_PROGRAMMES = [
  {
    code: 'JS1102',
    short_name: 'BSc',
    full_title_en: 'Bachelor of Science',
    full_title_cn: '理學士',
    institution: 'The University of Hong Kong',
    duration: '4 years',
    intake: '120',
    interview: 'No',
    stats_apply: [[2024, 450, 200, 150, 100, 50, 950]],
    stats_offer: [[2024, 120, 55, 40, 25, 12, 252]],
    url: 'https://www.jupas.edu.hk',
  },
  {
    code: 'JS3400',
    short_name: 'BSc',
    full_title_en: 'Bachelor of Science in Quantitative Finance',
    full_title_cn: '理學士（量化金融）',
    institution: 'The Chinese University of Hong Kong',
    duration: '4 years',
    intake: '45',
    interview: 'Yes (on a selective basis)',
    stats_apply: [[2024, 180, 90, 60, 40, 20, 390]],
    stats_offer: [[2024, 42, 20, 14, 8, 4, 88]],
    url: 'https://www.jupas.edu.hk',
  },
];
